export default __webpack_public_path__ + "static/media/Soccer.8beb6ecf.png";